export const LOGIN_REDIRECTION_QUERY = 'query'
export const LOGIN_REDIRECTION_NAME = 'name'
